<template>
  <div>
    <BaseDataTable
      :headers="COLLABORATORS_HEADER"
      :items="activeOrganization.collaborators"
      :loading="isLoadingActiveOrganizationCollaborators"
      :loading-text="$t('utils.loadingData')"
      class="elevation-1 mb-6"
    >
      <template #item="{ item }">
        <tr>
          <td>
            <BaseParagraph v-text="item.user.email" />
          </td>
          <td>
            <BaseParagraph
              v-if="item.user.fullName"
              v-text="item.user.fullName"
            />
            <BaseParagraph v-else italic v-text="$t('answer.noContent')" />
          </td>
          <td>
            <BaseParagraph
              v-if="/^ADMINISTRATOR$/.test(item.status)"
              v-text="$t('utils.administrator')"
            />
            <BaseParagraph
              v-else-if="/^MEMBER$/.test(item.status)"
              v-text="$t('organization.member')"
            />
          </td>
          <td v-if="userStatus === 'ADMINISTRATOR'">
            <template v-if="displayAction(item)">
              <div class="action_section">
                <BaseButtonIcon
                  x-small
                  color="primary"
                  icon="$mdiPencilOutline"
                  @click="openEditModal(item)"
                />
                <BaseButtonIcon
                  color="secondary"
                  x-small
                  icon="$mdiTrashCanOutline"
                  @click="
                    () => {
                      $store.commit(
                        'organization/SET_ACTIVE_COLLABORATOR',
                        item
                      );
                      $store.commit(
                        'organization/SET_REMOVE_COLLABORATOR_DIALOG_STATUS',
                        true
                      );
                    }
                  "
                />
              </div>
            </template>
          </td>
        </tr>
      </template>
    </BaseDataTable>
    <EditCollaboratorFunction
      v-if="editModalOpened"
      :collaborator="collaboratorToEdit"
      @collaboratorUpdated="handleCollaboratorUpdated($event)"
      @close="editModalOpened = false"
    />
    <OrganizationRemoveCollaboratorDialog />
  </div>
</template>

<script>
import { mapState } from "vuex";
import EditCollaboratorFunction from "./EditCollaboratorFunction";
import OrganizationRemoveCollaboratorDialog from "./OrganizationRemoveCollaboratorDialog";

export default {
  name: "OrganizationDashboardCollaborators",
  components: {
    OrganizationRemoveCollaboratorDialog,
    EditCollaboratorFunction,
  },
  data() {
    return {
      COLLABORATORS_HEADER: [
        {
          text: this.$tc("utils.email", 1),
          value: "email",
        },
        {
          text: this.$tc("utils.fullname"),
          value: "fullName",
        },
        {
          text: this.$tc("utils.function"),
          value: "status",
        },
      ],
      userStatus: "MEMBER",
      editModalOpened: false,
      collaboratorToEdit: null,
    };
  },
  computed: {
    ...mapState({
      activeOrganization: (state) => state.organization.activeOrganization,
      isLoadingActiveOrganizationCollaborators: (state) =>
        state.organization.isLoadingActiveOrganizationCollaborators,
      user: (state) => state.account.user,
    }),
    activeCollaborator() {
      if (!this.user) return null;
      return this.activeOrganization.collaborators.find(
        (c) => c.user.id === this.user.id
      );
    },
  },
  watch: {
    "activeOrganization.id": {
      handler() {
        this.initialize();
      },
      immediate: true,
    },
  },

  methods: {
    async initialize() {
      await this.$store.dispatch(
        "organization/fetchOrganizationCollaborators",
        this.activeOrganization.id
      );
      this.userStatus = this.getUserStatus();
      if (this.userStatus === "ADMINISTRATOR") {
        this.COLLABORATORS_HEADER.push({
          text: this.$tc("utils.action", 2),
          align: "end",
          sortable: false,
        });
      }
    },
    getUserStatus() {
      if (!this.user || !this.activeOrganization.collaborators) return "MEMBER";
      return this.activeOrganization.collaborators.find(
        (c) => c.user.id === this.user.id
      ).status;
    },
    handleCollaboratorUpdated(item) {
      this.$store.commit("organization/UPDATE_COLLABORATOR", item);
      if (!this.activeCollaborator) return;
      if (
        item.user.id == this.activeCollaborator.user.id &&
        item["function"] == "MEMBER"
      )
        this.redirectToDashboard();
    },
    openEditModal(item) {
      this.collaboratorToEdit = item;
      this.editModalOpened = true;
    },
    displayAction(collaborator) {
      if (
        this.activeOrganization.collaborators.filter(
          (c) => c.status == "ADMINISTRATOR"
        ).length > 1
      )
        return true;
      const lastAdministrator = this.activeOrganization.collaborators.find(
        (c) => c.status == "ADMINISTRATOR"
      );
      if (!lastAdministrator) return false;
      return lastAdministrator.id != collaborator.id;
    },
    redirectToDashboard() {
      this.$router.push({
        name: "ORGANIZATION_DASHBOARD",
        params: { organizationId: this.activeOrganization.id },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.action_section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}
</style>
